export default __webpack_public_path__ + "static/media/img-0238-australia-full-face.8bc9f984.png";